<template>
  <div>
    <a-tooltip placement="bottom">
      <template slot="title">
        {{ isFullscreen ? '退出全屏' : '切为全屏' }}
      </template>
      <a-icon :type="isFullscreen ? 'fullscreen-exit' : 'fullscreen'" @click="click" :style="{ fontSize: '20px' }"/>
    </a-tooltip>
  </div>
</template>

<script>
import screenfull from 'screenfull'
import io from "socket.io-client";

import {notification}  from 'ant-design-vue';
import storage from "store";
import {SHOP_ID} from "@/store/mutation-types";
export default {
  name: 'Screenfull',
  data () {
    return {
      msg:{},
      clientSocket: null,
      message1: "",
      messageList1: [],
      shopId:'',

      isFullscreen: false
    }
  },

  created() {
    this.shopId = storage.get(SHOP_ID)
    if (!this.shopId) {
      console.error('未获取到shopId，请确保已登录并选择了店铺')
      return
    }
    this.createClient()
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.destroy()
  },
  methods: {
    notificationMsg(msg){
      const key = `open${Date.now()}`
      notification.info({
        message: msg.title,
        description: msg.text,
        duration: 10000,
        btn: h => h('div',
          [
            h('a-button',
              {
                props: {
                  size: 'small'
                },
                attrs: {
                  style: 'margin-right:40px'
                },
                on: {
                  click: () => notification.close(key)
                }
              }, '稍后处理'),
            h('a-button', {
              props: {
                type: 'primary',
                size: 'small'
              },

              on: {
                click: () => {
                  if (msg.type==1){
                    this.$router.push('/order/sell')
                    notification.close(key)
                  }else {
                    this.$router.push('/order/refund')
                    notification.close(key)
                  }

                }
              }
            }, '立即处理')
          ]),
        key
      })

    },

    createClient() {
      if (!this.shopId) {
        console.error('shopId is undefined')
        return
      }

      const opts = {
        query: 'shopId=' + this.shopId,
        transports: ['websocket'],
        upgrade: false,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        timeout: 10000,
        debug: true
      }

      try {
        this.clientSocket = io.connect('http://39.103.60.179:33000', opts)

        this.clientSocket.on("connect_error", (error) => {
          console.error("连接错误:", error)
        })

        this.clientSocket.on("connect_timeout", (timeout) => {
          console.error("连接超时:", timeout)
        })

        this.clientSocket.on("connect", () => {
          console.log("连接成功客户端", this.shopId)
        })

        this.clientSocket.on('disconnect', (reason) => {
          console.log("连接断开，原因:", reason)
        })

        this.clientSocket.on('channel_user', (data) => {
          console.log("收到消息了"+data);
          if (data == 1){
            //购买订单
            console.log("=============="+data);
            // this.$refs.audioPlayer1.play()
            this.msg={
              title:"订单消息通知",
              text:"您有新购买订单，请及时处理",
              type: 1
            }
          }
          if (data == 2){
            //退款订单
            console.log("=============="+data);
            this.msg={
              title:"订单消息通知",
              text:"您有新退款订单，请及时处理",
              type: 2
            }
            // this.$refs.audioPlayer2.play()
            this.msg={
              title:"订单消息通知",
              text:"您有新退款订单，请及时处理",
              type: 2
            }
          }
          if (data == 3){
            //退货订单
            console.log("=============="+data);
            this.msg={
              title:"订单消息通知",
              text:"您有新退货物流信息订单，请及时处理",
              type: 3
            }
            // this.$refs.audioPlayer3.play()

          }
          this.notificationMsg(this.msg)
        });

      } catch (error) {
        console.error("连接失败:", error)
      }
    },

    click () {
      if (!screenfull.isEnabled) {
        this.$message.warning('你的浏览器不支持全屏')
        return false
      }
      screenfull.toggle()
    },
    change () {
      this.isFullscreen = screenfull.isFullscreen
    },
    init () {
      if (screenfull.isEnabled) {
        screenfull.on('change', this.change)
      }
    },
    destroy () {
      if (screenfull.isEnabled) {
        screenfull.off('change', this.change)
      }
    }
  }
}
</script>
